import { useState, useEffect } from 'react';

type CopiedType = boolean;
type CopyFn = (text: string) => void;

export default function useCopyToClipboard(
  resetTime: number
): [CopiedType, CopyFn] {
  const [copied, setCopied] = useState<CopiedType>(false);

  const copy: CopyFn = async (text) => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
  };

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout>;
    if (resetTime && copied) {
      timerId = setTimeout(() => {
        setCopied(false);
      }, resetTime);
    }
    return () => clearTimeout(timerId);
  }, [copied, resetTime]);

  return [copied, copy];
}
